module.exports = __webpack_public_path__ + "static/img/ccod8.ff0603f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod8.png
// module id = ioqH
// module chunks = 0